module.exports = __webpack_public_path__ + "static/img/ademe-logo.41e0fe2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ademe-logo.png
// module id = Ha3K
// module chunks = 1